import React from "react";
import pageClasses from "./DCCostFlow.module.css";

const DCCostFlowPage = ({ title, description, children }) => (
  <section className={pageClasses.page}>
    <header className={pageClasses.header}>
      <h1>{title}</h1>
      {description ? <p>{description}</p> : null}
    </header>
    <div className={pageClasses.card}>{children}</div>
  </section>
);

export default DCCostFlowPage;
